export default {
  strToList (str) {
    let arr = []
    if (str) {
      arr = str.split(',')
    }
    return arr
  },
  /**
   * 去除html标签
   * @param str
   * @returns {*}
   */
  delHtmlTag (str) {
    if (str) {
      return str.replace(/<[^>]+>/g, '')
    } else {
      return null
    }
  }
}



// WEBPACK FOOTER //
// ./src/utils/index.js